var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex fill-height"},[_c('v-row',_vm._l((_vm.members),function(member){return _c('v-col',{key:member.id,attrs:{"cols":_vm.$reactive.isDesktop() ? 6 : 12}},[_c('MemberCard',_vm._b({},'MemberCard',{
                    member,
                    loading: _vm.localLoading
                },false))],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }